import React from 'react';

const useWatchFormValues = (fieldNames = [], initialValues = {}) => {
  const [formValues, setFormValues] = React.useState(() =>
    fieldNames.reduce((acc, fieldName) => {
      acc[fieldName] = initialValues[fieldName];
      return acc;
    }, {}),
  );

  const handler = React.useCallback(
    (_, allValues) => {
      const values = fieldNames.reduce((acc, fieldName) => {
        if (allValues[fieldName]) {
          acc[fieldName] = allValues[fieldName];
        }
        return acc;
      }, {});

      if (Object.keys(values).length) {
        setFormValues((prev) => ({ ...prev, ...values }));
      }
    },
    [fieldNames],
  );

  return [formValues, handler];
};

export default useWatchFormValues;
